import Vue, { VNode } from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import VuePageTransition from "vue-page-transition";
import "./registerServiceWorker";
import router from "./router";
import "@/assets/scss/custom.scss";
import store from "./store";
import i18n from "./i18n";
import VueMatomo from "vue-matomo";

Vue.use(BootstrapVue);
Vue.use(VuePageTransition);

Vue.use(VueMatomo, {
  host: "https://usp.matomo.cloud",
  siteId: process.env.NODE_ENV === "production" ? 2 : 3,
  domains: "dba.usp.at",
  router: router,
  disableCookies: true,
  requireConsent: false
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h): VNode => h(App)
});

i18n.locale = "ru";

export const EventBus = new Vue();
